import {Banner} from '@primer/react'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useSessionContext} from '../../contexts/SessionContext'
import {useAgentInfo} from '@github-ui/copilot-shared-ui/agents/use-agent-info'
import {renderTextWithLinks} from '../../utils/render-text-with-links'

interface SessionTimedOutBannerProps {
  timeoutMessage: string | null
  workflowRunLink: string | null
}

export function SessionTimedOutBanner({timeoutMessage, workflowRunLink}: SessionTimedOutBannerProps) {
  const {session} = useSessionContext()
  const {data: agentInfo} = useAgentInfo(session.agent_id, session.agent_slug)
  const defaultTimeoutMessage =
    'The session timed out before work could be completed. For more details, see the detailed logs in GitHub Actions.'
  const sessionTimedOutMessage = timeoutMessage || defaultTimeoutMessage
  const handleDetailedLogsClick = () => {
    sendEvent('agent_sessions.task_view', {
      target: 'CLICK_SESSION_ERROR_LOGS_LINK',
      session_id: session.id,
      task_id: session.resource_global_id,
    })
  }

  return (
    <Banner
      aria-label="Session timed out"
      title={`${agentInfo?.display_name || 'Agent'} timed out`}
      description={renderTextWithLinks(sessionTimedOutMessage)}
      variant="critical"
      actionsLayout="stacked"
      primaryAction={
        workflowRunLink && (
          <Banner.PrimaryAction as="a" href={workflowRunLink} onClick={handleDetailedLogsClick}>
            View run
          </Banner.PrimaryAction>
        )
      }
    />
  )
}
